import { useRef } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { RfidCard } from "../hooks/useRfidCards";

export function RfidActionsCell({
    row,
    onAssign,
    onUnassign,
    onDeactivate,
    onDelete,
    onUpdate
}: {
    row: RfidCard;
    onAssign: (uid: string) => void;
    onUnassign: (uid: string) => void;
    onDeactivate: (uid: string) => void;
    onDelete: (uid: string) => void;
    onUpdate: (uid: string, cardCode: string, validUntil: string | null, status: RfidCard["status"]) => void;
}) {
    const menu = useRef<Menu>(null);

    const items: MenuItem[] = [];
    if (row.status === "INACTIVE") {
        items.push(
            {
                label: "Update",
                icon: "pi pi-pencil",
                command: () => onUpdate(row.uid, row.card_code, row.valid_until, row.status)
            },
            {
                label: "Deactivate",
                icon: "pi pi-ban",
                command: () => onDeactivate(row.uid)
            },
            {
                label: "Delete",
                icon: "pi pi-trash",
                className: "text-red-500",
                command: () => onDelete(row.uid)
            }
        );
    } else if (row.status === "ACTIVE") {
        items.push(
            {
                label: "Update",
                icon: "pi pi-pencil",
                command: () => onUpdate(row.uid, row.card_code, row.valid_until, row.status)
            },
            {
                label: "Deactivate",
                icon: "pi pi-ban",
                command: () => onDeactivate(row.uid)
            }
        );
    }

    return (
        <div className="flex gap-2 align-items-center">
            {row.status === "INACTIVE" && (
                <Button
                    style={{ minWidth: "125px" }}
                    icon="pi pi-user-plus"
                    label="Assign"
                    rounded
                    size="small"
                    onClick={() => onAssign(row.uid)}
                />
            )}

            {row.status === "ACTIVE" && (
                <Button
                    style={{ minWidth: "125px" }}
                    icon="pi pi-user-minus"
                    label="Unassign"
                    rounded
                    size="small"
                    severity="warning"
                    onClick={() => onUnassign(row.uid)}
                />
            )}

            {row.status === "DEACTIVATED" && (
                <Button
                    style={{ minWidth: "125px" }}
                    icon="pi pi-ban"
                    label="Deactivated"
                    rounded
                    outlined
                    size="small"
                    severity="secondary"
                    disabled
                />
            )}

            {items.length > 0 && (
                <>
                    <Menu model={items} popup ref={menu} id={`popup_menu_${row.uid}`} />
                    <Button
                        icon="pi pi-ellipsis-v"
                        rounded
                        outlined
                        size="small"
                        severity="secondary"
                        style={{ width: '2rem', height: '2rem', padding: '17px' }}
                        onClick={(event) => menu.current?.toggle(event)}
                        aria-controls={`popup_menu_${row.uid}`}
                        aria-haspopup
                    />
                </>
            )}
        </div>
    );
}